<template><div><h1>VUX V2.2.1Rc.6 released</h1>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[feature] Support slot:inline-desc</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] Add param names for display-format</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] Fix popup classname get lost</li>
<li>[feature] Support prop:show-mask</li>
<li>[feature] Support prop:position</li>
<li>[feature] Support prop:width</li>
</ul>
<h2><a href="/en/components/scroller.html">Scroller</a></h2>
<ul><li>[feature] Support event:on-scroll-bottom</li>
<li>[fix] Disable trigger click</li>
</ul>
<h2><a href="/en/components/selector.html">Selector</a></h2>
<ul><li>[fix] fix placeholder. #1273</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] Support prop:display-format</li>
</ul>
<h2><a href="/en/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[enhance] set label align to flex-start</li>
<li>[feature] Support prop:autosize</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.6 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.6-105.vue?107b1c1c